import { Select } from "antd";
import { NamePath } from "antd/es/form/interface";
import FormItem from "components/form/FormItem";
import { useRestContext } from "components/form/RestInputContext";
import _, { map } from "lodash";
import { useEffect, useState } from "react";
import { DynamicObjectType } from "types/commons";
import { getRecordData } from "utils/tools";

const { Option } = Select;

interface SelectCustomTypes {
   disabled?: boolean,
   placeholder?: string,
   header?: string,
   required?: boolean,
   source: NamePath,
   subSource: NamePath,
   resourceData: DynamicObjectType[],
   valueProp?: string,
   titleProp?: string,
   allowClear?: boolean,
   formOptions?: DynamicObjectType,
}

export default function SelectCustom({
   disabled,
   placeholder,
   header,
   required,
   source,
   subSource,
   resourceData,
   valueProp = 'id',
   titleProp = 'name',
   allowClear,
   formOptions,
} : SelectCustomTypes) {
   const { form, record } = useRestContext();
   const defaultValue = getRecordData(record, source);
   const [options, setOptions] = useState([]);

   const onSearch = (value: string) => {
      if (value) {
         const filter = _.filter(resourceData, val => _.includes(_.toLower(_.deburr(val.name)), _.toLower(_.deburr(value))));
         setOptions(filter);
      } else {       
         setOptions(resourceData);
      }
   };

   const handleSelect = (value) => {
      const selectedData = options?.find((data) => getRecordData(data, valueProp) === value);
      form.setFieldsValue({
         [subSource]: selectedData?.name,
      });
   }
   
   useEffect(() => {
      setOptions(resourceData);
   }, [resourceData]);   

   return (
      <>
         <FormItem
            ruleType={Array.isArray(defaultValue) ? 'array' : 'string'}
            formOptions={formOptions}
            disbaled={disabled}
            placeholder={placeholder}
            label={header}
            required={required}
            initialValue={
               defaultValue?.map?.((e) => e?.id || e) ||
               defaultValue?.id ||
               defaultValue
            }
            name={source}
         >
            <Select
               allowClear={allowClear}
               showSearch
               onSearch={onSearch}
               onSelect={handleSelect}
               filterOption={() => true}
            >
               {map(options, (data) => (
                  <Option
                     key={getRecordData(data, valueProp)}
                     value={getRecordData(data, valueProp)}
                  >
                     {getRecordData(data, titleProp)}
                  </Option>
               )
               )}
            </Select>
         </FormItem>
         <FormItem name={subSource} hidden />
      </>
   )
}